export async function postRecoveryCode(body, cb = () => {}) {
  const response = await fetch(`api/recovery/code/create`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
  });
  if (response.ok) {
      const data = await response.json();
      cb(null,data);
  } else {
      const data = await response.json();
      cb(data || response.status);
  }
}


export async function postValidateRecoveryCode(body, cb = () => {}) {
  const response = await fetch(`api/recovery/code/confirm`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
  });
  if (response.ok) {
      const data = await response.json();
      cb(null,data);
  } else {
      const data = await response.json();
      cb(data || response.status);
  }
}


export async function postChangePassword(body, cb = () => {}) {
  const response = await fetch(`api/recovery/changepassword`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
  });
  if (response.ok) {
      const data = await response.json();
      cb(null,data);
  } else {
      const data = await response.json();
      cb(data || response.status);
  }
}